import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import styles from './PageSpinner.module.css';

const PageSpinner = () => {
  return (
    <Box className={styles.spinnerWrapper}>
      <CircularProgress />
    </Box>
  );
};

export default PageSpinner;